import { Availability } from '../AvailabilityView';
import { Box, Container } from '@chakra-ui/react';
import { PickerEmptyState, PickerField, PickerRow } from './pickerUi';
import { useState } from 'react';

export const Picker8K = (props: any) => {
	const [isValidating] = useState(false);
	const [code, setCode] = useState('');
	const isFilled = Boolean(code);

	const handleCodeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		setCode(event.currentTarget.value);
	};

	return (
        <Box pb={2}>
            <PickerRow>
                <PickerField
                    label="Przedmiot"
                    value={code}
                    invalid={!code && isValidating}
                    placeholder="- przedmiot -"
                    onChange={handleCodeChange}
                >
                    <option value="mat_kurs_8K">matematyka</option>
                    <option value="pol_kurs_8K">j. polski</option>
                    <option value="ang_kurs_8K">j. angielski</option>
                </PickerField>
            </PickerRow>
            {isFilled ? (
				<Availability
					code={code}
					type="8K"
					onPick={(lesson: any) =>
						props.onPick({
							...lesson,
							subjectCode: code.substring(0, 3),
							kind: 'Kurs ósmoklasisty',
						})
					}
				/>
			) : (
				<Container centerContent>
					<PickerEmptyState count={1} />
				</Container>
			)}
        </Box>
    );
};
